import React from "react";

const WhiteBackground = ({ children, fullHeight = true }) => {
  return (
    <div
      style={{
        display: "flex",
        width: "100%",
        height: fullHeight ? "100dvh" : "auto",
        minHeight: fullHeight ? "" : "100dvh",
        background: "white",
        overflow: "auto",
        overflowX: "hidden",
        flexDirection: "column",
      }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: fullHeight ? "100dvh" : "auto",
          minHeight: fullHeight ? "" : "100vh",
        }}
      >
        {children}
      </div>
    </div>
  );
};

export default WhiteBackground;
